module.exports = __webpack_public_path__ + "static/media/in-progress.3692dff3.svg";